import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import Modal from 'react-responsive-modal';
import html2canvas from 'html2canvas';
import ContentEditable from 'react-contenteditable';
import Countdown from 'react-countdown-now';
import * as util from '../../utils/util';
// import { FaArrowCircleRight } from 'react-icons/fa';
import { Dimmer, Loader, Image, Segment } from 'semantic-ui-react'
import HttpUtils from '../../utils/http';

import CustomerProductRow from '../../components/customersuccessportal/CustomerProductRow';
import CustomerOrderHistory from './CustomerOrderHistory';
import SelectButton from '../../components/icon/SelectButton';
import { skinConcernIcons, allergicIngredientIcons, budgetArray, productTypeUpdated, RESPONSE_STATUS } from '../../utils/constants';

import './CustomerInfoAndProducts.css';

import Api from '../../utils/api';
import {getTodayDate} from '../../utils/util';
// import Report from 'bugsnag-js/types/report';

let productFeedArr = [];
let productRow = [];
const quoteArr = [
    "“Love yourself. It is important to stay positive because beauty comes from the inside out.” —Jenn Proske, Canadian Actress",
    "“Find your own way, have an open spirit, and believe in your own beauty.” —Francois Nars, French Businessman",
    "“Beauty is power; a smile is its sword.” —John Ray, English Environmentalist ",
    "“Beauty is when you can appreciate yourself. When you love yourself, that's when you're most beautiful.” —Zoe Kravitz, American Actress",
    "“Imperfection is beauty, madness is genius and it's better to be absolutely ridiculous than absolutely boring.” —Marilyn Monroe, American Actress",
    "“Beauty is being comfortable and confident in your own skin.” —Iman, Somali-American Model and Actress"
];
const indexMap = {1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,9:true,10:true};
const indexMapThreeFive = {13:true,14:true};
const indexMapProducts = {1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,11:true,12:true,15:true};
const indexMapBudget = {1:true, 2:true, 3:true, 4:true};


class CustomerInfoAndProducts extends Component {
    constructor(props){
        super(props);

        this.state = {
            email: '',
            noData: false,
            loadingDone: false,
            name: '',
            showProducts: true,
            photos: [],
            showPhotoModal: false,
            id: null,
            showRegimenModal: false,
            showDummyDiv: false,
            hideButtons: false,
            selectedOrderForRegimenCard: [],
            imageURL: '',
            showEditMode: false,
            editHtml: '',
            editHtmlOriginal: '',
            notDefault: false,
            isEditingProducts: false,
            isEditingAllergies: false,
            isEditingSkinConcerns: false,
            isEditingBudget: false,
            skinConcerns: [],
            productTypes: [],
            allergicIngredients: [],
            selectedAllergicMap: {},
            selectedSkinConcernMap: {},
            budget: null,
            showCategoryEditSection: false,
            skinImageExists: true,
            startTime: null,
            purchasedTime: null,
            paidGateFee: false,
            defaultPurchaseStarted: false,
            defaultPurchaseComplete: false,
            defaultPurchaseOptOut: false,
            orderId: null,
            purchasedViaTimer: false,
            updateEmialValue: '',
            isEmailEditButtonShow:true,
            isEmailEditInputShow:false,
            showPrintImg:false,
            brands:[],
            note: '',
            isCheckoutButton:false,
            dataURLBse64:'',
            sourceOrderId: '',
            loadingState:false,
            leavingAmessageNode:'',
            leavingAmessageNodeId:'',
            operationStep:'edit',
        };

        this.updateAfterChange = this.updateAfterChange.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.getSelectedOrderForRegimenCard = this.getSelectedOrderForRegimenCard.bind(this);
        this.generateEditedRegimenCard = this.generateEditedRegimenCard.bind(this);
        this.printImage = this.printImage.bind(this);
        this.toggleEditMode = this.toggleEditMode.bind(this);
        this.handleEditInputChange = this.handleEditInputChange.bind(this);
        this.handleEditCancel = this.handleEditCancel.bind(this);
        this.handleEditReset = this.handleEditReset.bind(this);
        this.selectPasIcon = this.selectPasIcon.bind(this);
        this.deselectPasIcon = this.deselectPasIcon.bind(this);
        this.saveProducts = this.saveProducts.bind(this);
        this.saveAllergies = this.saveAllergies.bind(this);
        this.saveSkinConcerns = this.saveSkinConcerns.bind(this);
        this.saveBudget = this.saveBudget.bind(this);
        this.savePreferences = this.savePreferences.bind(this);
        this.handleOptOut = this.handleOptOut.bind(this);
        this.toggleCategoryEditSection = this.toggleCategoryEditSection.bind(this);
        this.deleteRegimenCard = this.deleteRegimenCard.bind(this);
        this.handleEditNoteEdit = this.handleEditNoteEdit.bind(this);
        this.fun_getNoteCustomer = this.fun_getNoteCustomer.bind(this);
        this.fun_stepChange = this.fun_stepChange.bind(this);
    }

    componentWillMount() {
        const passwordSubmitted = localStorage.getItem('password_correct');
        const emailSubmitted = localStorage.getItem('email_submitted');
        const customerEmailSelectedSplit = this.props.location.pathname.split("/");
        const customerEmailSelected = customerEmailSelectedSplit[customerEmailSelectedSplit.length - 1];
        const userId = localStorage.getItem("user_id");

        this.unlisten = this.props.history.listen((location, action) => {
          if (emailSubmitted) localStorage.removeItem('email_submitted');
        });


        if (!userId) {
            this.props.history.push('/signin');
        } else {
            if (!passwordSubmitted) {
                this.props.history.push({
                    pathname: '/portal'
                });
            } else if (!emailSubmitted) {
                this.props.history.push({
                    pathname: '/portal/customer-tool'
                });
            } else {

                this.setState({ customerEmail: customerEmailSelected }, () => {
                    this.getCustomerInfo(function() {
                        if (this.state.name) {
                            this.fetchResult();
                            this.checkIfCardIsOnStripe();
                            this.fun_handleGetNote();
                            this.fun_getNoteCustomer();
                        }
                        else this.setState({ noData: true });
                    });
                });

            }
        }
    }



    componentWillUnmount() {
        this.unlisten();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
        }
      }

    //Default Purchase Functions For Timer
    checkIfCardIsOnStripe() {
        // const userId = localStorage.getItem("user_id");
        const userId = this.state.id;
        fetch('/api/stripe-customers/status?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then(response => response.json())
        .then(responseJson => {
            if (responseJson) {
                this.setState({ paidGateFee: true });
                this.checkDefaultPurchaseStatus();
            } else {
                return;
            }
        })
        .catch(err => {
            alert('There was a problem checking for eligibility: ' + err);
        });
    }

    checkIfPurchasedViaTimer() {
        const date1 = new Date(this.state.startTime);
        const date2 = new Date(this.state.purchasedTime);
        const finalTime = Math.abs((date2.getTime() - date1.getTime()) / (1000 * 60 * 60));
        if (finalTime >= 72) this.setState({ purchasedViaTimer: true });
        else this.setState({ purchasedViaTimer: false });
    }

    checkDefaultPurchaseStatus() {
        // const userId = localStorage.getItem("user_id");
        const userId = this.state.id;
        fetch('/api/default-purchases?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then(response => {
            if (response.status >= 400 && response.status < 500) {
                // this.startTimerOptIn();
                throw new Error("pass");
            } else {
                return response.json();
            }
        })
        .then(responseJson => {
             if (responseJson.status && ((responseJson.status === "complete") || (responseJson.status === "opt-out"))) {
                if (responseJson.status === "complete") {
                    console.log("complete");
                    this.setState({
                        startTime: responseJson.createdDate,
                        defaultPurchaseStarted: false,
                        defaultPurchaseComplete: true,
                        defaultPurchaseOptOut: false,
                        purchasedTime: responseJson.lastModifiedDate
                    });
                } else {
                    this.setState({
                        startTime: responseJson.createdDate,
                        defaultPurchaseStarted: false,
                        defaultPurchaseComplete: false,
                        defaultPurchaseOptOut: true,
                        purchasedTime: null
                    });
                }

            } else {
                this.setState({
                    startTime: responseJson.createdDate,
                    defaultPurchaseStarted: true,
                    defaultPurchaseComplete: false,
                    defaultPurchaseOptOut: false,
                    purchasedTime: responseJson.lastModifiedDate
                });
            }
            this.checkIfPurchasedViaTimer()
        })
        .catch(err => {
            return;
            // else alert("There was a problem checking the user's default purchase status: " + err);
        });
    }

    handleOptOut() {
        const userId = this.state.id;
        fetch('/api/default-purchases/opt-out?user-id=' + userId, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then(response => {
            if (response.status === RESPONSE_STATUS.OK || (response.status >= 200 && response.status < 300)) {
                this.getCustomerInfo(function() {
                    this.updateAfterChange();
                });
            } else {
                throw new Error("Server response error.")
            }
        })
        .catch(err => {
            alert('There was a problem opting out of your purchase: ' + err);
        });

    }


    onOpenModal = () => {
        this.setState({ showPhotoModal: true });
    };

    onCloseModal = () => {
        this.setState({ showPhotoModal: false });
    };

    onOpenRegimenModal = () => {
        this.setState({ showRegimenModal: true });
    };

    onCloseRegimenModal = () => {
        this.setState({ showRegimenModal: false, showEditMode: false });
    };

    handleDummyDiv = () => {
        this.setState({ showDummyDiv: !this.state.showDummyDiv });
    }

    updateAfterChange() {
        this.setState({ loadingDone: false },
            function() {
                this.getCustomerInfo(function() {
                    if (this.state.name) {
                        this.fetchResult();
                        this.checkIfCardIsOnStripe();
                    } else {
                        this.setState({ noData: true });
                    }
                });
            }
        );
    }
    getCustomerInfo(callback) {
        // if (localStorage.getItem("user_id")) localStorage.removeItem("user_id");
        // const email = localStorage.getItem('customer_email');
        const email = this.state.customerEmail;
        const url = '/api/user-account-info?email=' + email;
        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then((response) => response.json())
        .then(responseJson => {
            // localStorage.setItem("user_id", responseJson.id);
            this.setState({
                id: responseJson.id,
                name: responseJson.name,
                firstName:responseJson.firstName,
                pregnancy: responseJson.pregnancy,
                email: responseJson.email,
                phoneNumber: responseJson.phoneNumber,
                photos: responseJson.photos,
                age: responseJson.age,
                skinType: responseJson.skinType.replace("W","M"),
                wrinkled: responseJson.skinType.charAt(3) === 'W'? "Mature" : "youthful",
                wrinkledType: responseJson.skinType.charAt(3),
                gender: responseJson.gender ? responseJson.gender.option : null,
                ethnicity: responseJson.ethnicity ? responseJson.ethnicity.option : null,
                budget: responseJson.budget !== null ? responseJson.budget.option : responseJson.budget,
                budgetId: responseJson.budget !== null ? responseJson.budget.id : responseJson.budget,
                recommendedProducts: responseJson.recommendedProducts,
                skinConcerns: responseJson.skinConcerns,
                skinConcernsId: responseJson.skinConcerns.map((concern) => { return concern.id }),
                allergicIngredients: responseJson.allergicIngredients,
                allergiesId: responseJson.allergicIngredients.map((allergy) => { return allergy.id }),
                productTypesRender: responseJson.productTypes,
                loadingDone: true,
                brands: responseJson.brands,
            }, callback);

  

        }).catch(function(err) {
            alert("There was a problem retrieving customer data: " + err);
        });
    }

    listUserChoices(input) {
        let userChoices = '';
        this.state[input].forEach((userChoice, index, arr) => {
            if (index === arr.length - 1) userChoices += userChoice.option;
            else userChoices += userChoice.option + ', ';
        });
        return userChoices;
    }

    renderCountdownTimer() {
        let dateStarted = new Date(this.state.startTime);
        dateStarted.setDate(dateStarted.getDate() + 3);

        const renderer = ({ days, hours, minutes, seconds, completed }) => {
          if (completed) {
            // Render a complete state
            return "Time expired.";
          } else {
            // Render a countdown
            return  <span className="timer">{days}d {hours}h {minutes}m {seconds}s</span>;
          }
        };

        return(
            this.state.startTime && this.state.startTime !== null ? <Countdown date={ dateStarted } renderer={renderer} /> : null
        );
    }

    handleMenuClick() {
        this.setState({ showProducts: !this.state.showProducts });
    }

    renderProductRows() {
        let prodTypesForRows = [];
        prodTypesForRows = this.state.recommendedProducts
        .filter((product) => {
            return (prodTypesForRows.indexOf(product.type) === -1);
        })
        .map((product, index, arr) => {
            return product.type;
        }).filter((type, index, arr) => { return arr.indexOf(type) === index });

        productFeedArr = prodTypesForRows.map((type,index) => {
            return (
                <CustomerProductRow
                    key={index}
                    rowNumber={index}
                    customerEmail={ this.state.customerEmail }
                    recommendedProducts={ this.state.recommendedProducts }
                    type={ type }
                    productRow={ productRow }
                    updateAfterChange={ this.updateAfterChange }
                    id={ this.state.id }
                />
            );
        });
        return productFeedArr;
    }

    generateQuote() {
        const randomIndex = Math.floor(Math.random() * ((quoteArr.length - 1) - 0 + 1));
        return quoteArr[randomIndex];
    }

    getSelectedOrderForRegimenCard(orderArr, orderId,sourceOrderId) {
        this.setState({ selectedOrderForRegimenCard: orderArr, showDummyDiv: true, showEditMode: false, orderId: orderId, sourceOrderId: sourceOrderId }, function() {
            this.getRegimenCard();
        });
    }

    generateEditedRegimenCard() {
        this.setState({ showRegimenModal: false, showDummyDiv: true, showEditMode: false  }, function() {
            this.saveRegimenCard();
        });

    }

    renderRegimenCardText() {
        // if (this.state.selectedOrderForRegimenCard.length) {
        const categoryOrderDaily = {
          "make-up remover": 1,
          "cleanser": 2,
          "toner": 3,
          "serum": 4,
          "moisturizer": 5,
          "eye cream": 6,
          "treatment": 7,
          "spf": 8,
          "supplement": 9
        };
    
        const categoryOrderWeekly = {
          "exfoliator": 1,
          "mask": 2
        }
        let productsType = [];
        let regimenTextDaily = [];
        let regimenTextWeekly = [];
        this.state.selectedOrderForRegimenCard.forEach((orderedProduct) => {
          if (orderedProduct.type.toLowerCase() === "exfoliator" || orderedProduct.type.toLowerCase() === "mask") {
            regimenTextWeekly.push({ name: orderedProduct.name, type: orderedProduct.type });
          } else {
            regimenTextDaily.push({ name: orderedProduct.name, type: orderedProduct.type });
          }
          try {
            productsType.push(orderedProduct.type.toLowerCase());
          } catch (error) {}
        });
    
        regimenTextDaily.sort((a, b) => {
          return categoryOrderDaily[a.type.toLowerCase()] - categoryOrderDaily[b.type.toLowerCase()];
        });
    
        regimenTextWeekly.sort((a, b) => {
          return categoryOrderWeekly[a.type.toLowerCase()] - categoryOrderDaily[b.type.toLowerCase()];
        });
    
      

    // console.log(regimenTextDaily)
    let regimenTextDailyRender = [];

     var _type_L;
     var makeArray = [],cleanserArray =[],tonerArray = [],serumArray = [],treatmentArray = [],moisturizerArray = [],eyeArray = [],spfArray = [],supplementArray = [];
     regimenTextDaily.map(order => {
        _type_L = order.type.toLowerCase();
          if (_type_L === "make-up remover"){
            makeArray.push(order.name);
          }else if(_type_L === "cleanser"){
            cleanserArray.push(order.name);
          }else if (_type_L === "toner") {
            tonerArray.push(order.name);
          }else if (_type_L === "serum") {
            serumArray.push(order.name);
          }else if (_type_L === "treatment"){
            treatmentArray.push(order.name);
          }else if (_type_L === "moisturizer"){
            moisturizerArray.push(order.name);
          }else if (_type_L === "eye cream"){
            eyeArray.push(order.name);
          }else if (_type_L === "spf"){
            spfArray.push(order.name);
          }else{
            supplementArray.push(order.name);
          }
    });

     if(makeArray.length >= 1){
        regimenTextDailyRender.push(`Remove make-up with ${makeArray.join(" or ")} (night)`);
     }
     

     if(cleanserArray.length >= 1){
        regimenTextDailyRender.push(`Cleanse with ${cleanserArray.join(" or ")} (day + night)`);
     }else{
        regimenTextDailyRender.push('Cleanse with your own cleanser (day + night)');
     }

     if(tonerArray.length >= 1){
        regimenTextDailyRender.push(`Tone with ${tonerArray.join(" or ")} (day + night)`);
     }

     if(serumArray.length >= 1){
        regimenTextDailyRender.push(`Treat with ${serumArray.join(" or ")} (day + night)`);
     }else{
        regimenTextDailyRender.push('Treat with your own serum (day+night)');
     }

     if(treatmentArray.length >= 1){
        regimenTextDailyRender.push(`Treat with ${treatmentArray.join(" or ")} (night)`);
     }

     if(moisturizerArray.length >= 1){
        regimenTextDailyRender.push(`Hydrate with ${moisturizerArray.join(" or ")} (day + night)`);
     }else{
        regimenTextDailyRender.push('Hydrate with your own moisturizer (day + night)');
     }

     if(eyeArray.length >= 1){
        regimenTextDailyRender.push(`Apply ${eyeArray.join(" or ")} on your under-eye area (day + night)`);
     }

     if(spfArray.length >=1){
        regimenTextDailyRender.push(`Protect with ${spfArray.join(" or ")} (day)`);
     }else{
        regimenTextDailyRender.push('Protect with your own SPF (day)');
     }

     if(supplementArray.length >=1){
        regimenTextDailyRender.push(`Take the ${supplementArray.join(" or ")} supplement (read instructions)`);
     }

        let regimenTextWeeklyRender = [],exfoliatorArray = [],pamperArray = []
        regimenTextWeekly.map(order => {
          const type = order.type.toLowerCase();
          if (type === "exfoliator"){
            exfoliatorArray.push(order.name);
          } 
          else {
            pamperArray.push(order.name);
          } 
        });

        if(exfoliatorArray.length >=1){
            regimenTextWeeklyRender.push(`Exfoliate once a week with ${exfoliatorArray.join(" or ")} (night)`)
        }

        if(pamperArray.length >=1){
            regimenTextWeeklyRender.push(`Pamper yourself with ${pamperArray.join(" or ")} (night)`)
        }

    
        var regimenClass = "regimen-text";
        if ((regimenTextDailyRender.length + regimenTextWeeklyRender.length) >= 6) {
          regimenClass = "regimen-text-long-conten-8";
        } else if ((regimenTextDailyRender.length + regimenTextWeeklyRender.length) >= 10) {
          regimenClass = "regimen-text-long-conten-6";
        }
    
        var regimenTextDailyRenderString = "";
        regimenTextDailyRender.forEach((element,key) => {
          regimenTextDailyRenderString+= `<li class="regimen-datail-li"> <div class="regimen-datail-li-serialNumber">${key+1}.</div> <div class="regimen-datail-li-conten">${element}<div> </li>`
        });
        var regimenTextWeeklyRenderString = "";
        regimenTextWeeklyRender.forEach((element,key) => {
          regimenTextWeeklyRenderString+= `<li class="regimen-datail-li"> <div class="regimen-datail-li-serialNumber">${key+1}.</div> <div class="regimen-datail-li-conten">${element}<div> </li>`
        });
    
    
        let regimenString = `<div class= ${regimenClass} ><div class="regimen-text-title">${regimenTextDailyRender.length > 0 ? "Daily" : ""}</div><ol class="daily regimen-datail">${regimenTextDailyRenderString}</ol><div className="regimen-text-title">${regimenTextWeeklyRender.length > 0 ? "Weekly" : ""}</div><ol class="weekly regimen-datail">${regimenTextWeeklyRenderString}</ol></div>`;
        let regimenStringOutput = regimenString.replace(",", "").replace(/,/g, '').trim();
    
        //If New Order
        this.setState({ editHtmlOriginal: regimenStringOutput });
        if (this.state.editHtml === "") this.setState({ editHtml: regimenStringOutput });
    
      } //end


    saveRegimenCard() {
        const url = '/api/regimen-cards';
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            },
            body: JSON.stringify({
                "userOrderId": this.state.orderId,
                "regimen": this.state.editHtml
            })
        }).then(response => {
            if (response.status >= 200 && response.status < 300) {
                console.log("Saved");
                this.renderRegimenCardText();
                // this.convertToCanvas();
            } else {
                alert("There was a problem saving the customer's regimen card. Please try again.");
            }
        });
    }

    deleteRegimenCard() {
        const orderId = this.state.orderId;
        fetch('/api/regimen-cards?order-id=' + orderId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then(response => response.json())
        .then(responseJson => {
            let id = responseJson.id;
            let deleteUrl = '/api/regimen-cards/' + id;

            fetch(deleteUrl, {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-auth-token': Api.auth_tokenManager()
                }
            })
            .catch(err => {
                alert('There was a problem deleting the regimen card');
            });
        })
        .catch(err => {
            alert('There was a problem getting the regimen card ID for deletion. Please try again.')
        })

    }
    getRegimenCard() {
        this.setState({ editHtml: "" }, () => {
            this.renderRegimenCardText();
            this.convertToCanvas();
        });
    }
    // getRegimenCard() {
    //     const orderId = this.state.orderId;
    //     fetch('/api/regimen-cards?order-id=' + orderId, {
    //         method: 'GET',
    //         headers: {
    //             'Accept': 'application/json',
    //             'Content-Type': 'application/json',
    //             'x-auth-token': Api.auth_tokenManager()
    //         }
    //     }).then((response) => {
    //         if (response.status >= 400 && response.status < 500) return;
    //         else if (response.status >= 500) throw new Error("Server error");
    //         else return response.json();
    //     }).then(responseJson => {
    //         if (responseJson && responseJson.regimen !== "") {
    //             this.setState({ editHtml: responseJson.regimen }, () => {
    //                  this.renderRegimenCardText();
    //                  this.convertToCanvas();
    //             });
    //         } else {
    //             this.setState({ editHtml: "" }, () => {
    //                  this.renderRegimenCardText();
    //                  this.convertToCanvas();
    //             });
    //         }
    //     }).catch(function(err) {
    //         console.log(err);
    //     });
    // }

    convertToCanvas() {
      this.setState({ showDummyDiv: true });
        let element = document.getElementById("regimen-card-dummy");
        let options = {
            scale: 3
        };
        if(this.state.sourceOrderId !== null){
            this.setState({
                loadingState:true
            })
        }

        html2canvas(element, options)
        .then((canvas) => {
            let dataURL = canvas.toDataURL('image/png', 0.3);
            let dataURLBse64 = dataURL.replace('data:image/png;base64,', '');

            if(this.state.sourceOrderId !== null){
                this.submitOrderCard(dataURLBse64);
            }
            
            if(this.state.sourceOrderId === null){
                this.setState({
                    imageURL: dataURL,
                    dataURLBse64: dataURLBse64,
                }, function() {
                    this.setState({
                        showDummyDiv: true
                    });
                });
    
                if (this.state.imageURL !== '') {
                    this.onOpenRegimenModal();
                    this.setState({ showDummyDiv: false });
                }
            }
           
        })
        .catch((err) => {
            alert("Error saving card.");
        });
    }

    submitOrderCard(imageBase64) {
     
        let _this = this;
        const sourceOrderId = this.state.sourceOrderId;
        const url = '/api/order-card';
        fetch(url, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-auth-token': Api.auth_tokenManager()
          },
          body: JSON.stringify({
            "orderId": `${sourceOrderId}`,
            "imageBase64": imageBase64,
            "userEmail":this.state.customerEmail
          })
        })
         .then((response) => response.json())
          .then(responseJson => {
            _this.setState({
                loadingState:false
            })
          }).catch(function (err) {
            _this.setState({
                loadingState:false
            })
          });
      }

    generateDate() {
        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();
        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
        let todayOutput = dd + "-" + mm + "-" + yyyy;
        return todayOutput;
    }

    printImage() {


        // this.setState({ hideButtons: true }, function() {
        //     // window.print();
        //     // this.setState({ hideButtons: false });
        // })

        this.setState({ showPrintImg: true }, function() {
              window.print();
            this.setState({ showPrintImg: false });
        })

    }

    toggleEditMode() {
        this.setState({ showEditMode: true });
    }

    handleEditInputChange(e) {
        this.setState({ editHtml: e.target.value });
    }

    handleEditNoteEdit(e) {
        let name = e.target.name;
        this.setState({ [name]: e.target.value });
    }

    fun_saveNoteCustomer(){
        if(this.state.leavingAmessageNodeId != ''){
            HttpUtils.put("/api/portal-esthetician-notes",{
                userId:this.state.id,
                id:this.state.leavingAmessageNodeId,
                note: this.state.leavingAmessageNode,
            }).then(response =>{
                this.setState({
                    operationStep:'edit',
                });
                alert('The operation was successful');
            })
        }else{
            HttpUtils.post("/api/portal-esthetician-notes",{
                userId:this.state.id,
                note: this.state.leavingAmessageNode,
            }).then(response =>{
                this.setState({
                    leavingAmessageNode: response.note,
                    leavingAmessageNodeId: response.id,
                    operationStep:'edit',
                })
                alert('The operation was successful');
            })
        }
       
    }

    fun_getNoteCustomer(){
        var id = this.state.id;
        HttpUtils.get(`/api/portal-esthetician-notes?user-id=${id}`).then(response =>{

            if(response && response.note.length > 0){
                this.setState({
                    leavingAmessageNode: response.note,
                    leavingAmessageNodeId: response.id
                })
            }else{
                this.setState({
                    leavingAmessageNodeId: response.id
                })
            }
        }).catch(err =>{
            console.log(err);
        })
    }

    fun_handleGetNote(){
        var id = this.state.id;
        HttpUtils.get(`/api/portal-notes?user-id=${id}`).then(response =>{
            this.setState({
                note: response.note,
                noteId:response.id,
            })
        })
    }

    fun_handleSubmitNote(){
        this.setState({isCheckoutButton:true});
        try {
            if(this.state.noteId){
                HttpUtils.put("/api/portal-notes",{
                    id: this.state.noteId,
                    userId:this.state.id,
                    note: this.state.note
                }).then(response =>{
                    this.setState({isCheckoutButton:false});
                    alert('The operation was successful');
                })
            }else{
                HttpUtils.post("/api/portal-notes",{
                    userId:this.state.id,
                    note: this.state.note
                }).then(response =>{
                    this.setState({isCheckoutButton:false});
                    alert('The operation was successful');
                })
            }
        } catch (error) {
            this.setState({isCheckoutButton:false});
            alert(error);
        }
      
    }

    fun_stepChange(){
        let templateText = this.state.leavingAmessageNode;
        if(this.state.leavingAmessageNode =='' || this.state.leavingAmessageNode == null){
            templateText = 'Hello '+this.state.firstName+',\n\nIt was such a pleasure to virtually meet you! I have put together a list of recommended products for you to choose from. Please also refer to your Skin Profile page for your suggested routine.\n\nPro tip: when introducing new products and ingredients you always want to start slow and add in one product at a time.  Adding in too many new products at once can often cause sensitivity and/or a reaction to skin.'
        }
        this.setState({
            operationStep:'save',
            leavingAmessageNode: templateText,
        },()=>{
            try {
                document.getElementById("custNoteDom").focus();
            } catch (error) {
                
            }
            
        });
    }



    handleEditCancel() {
        this.setState({ showEditMode: false });
    }

    handleEditReset() {
        this.setState({ editHtml: this.state.editHtmlOriginal }, this.deleteRegimenCard);
    }

    renderBlockSection() {
        const isEditingProducts = this.state.isEditingProducts;
        let allProductThreeFiveMap = Object.assign({}, indexMapThreeFive);
        let allProductMap = Object.assign({}, indexMapProducts);
        const allProductOptionsThreeFive = Object.keys(allProductThreeFiveMap).sort().map(index => {
            let name = util.capitalize(productTypeUpdated[index - 1].replace(".svg", "").replace("-", " "));
           return (
                <div key={ index } className="option full" >
                <SelectButton name={ name } selectable={ isEditingProducts }
                    selected={ this.state.productTypes && this.state.productTypes.indexOf(parseInt(index, 10)) > -1 } id={ "product-" + index }
                    onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
                </div>
            );
        });
        const allProductOptions = Object.keys(allProductMap).sort().map(index => {
            let name = util.capitalize(productTypeUpdated[index - 1].replace(".svg", "").replace("-", " "));
            return(
                <div key={ index } className="option" >
                    <SelectButton name={ name } selectable={ isEditingProducts }
                    selected={ this.state.productTypes && this.state.productTypes.indexOf(parseInt(index, 10)) > -1 } id={ "product-" + index }
                    onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
                </div>
            );
        });

        //ALLERGENS
        let selectedAllergicMap = Object.assign({}, indexMap);
        const allAllergicOptions = Object.keys(selectedAllergicMap).sort().map(index => {
            return (
                <div key={ index } className="option">
                    <SelectButton name={  util.capitalize(allergicIngredientIcons[index - 1].replace(".svg", "").replace("-", " ")) } selectable={ isEditingProducts }
                        selected={ this.state.allergiesId && this.state.allergiesId.indexOf(parseInt(index, 10)) > -1 } id={ "allergic-" + index }
                        onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
                </div>
            );
        });

        //SKIN CONCERNS
        let selectedSkinConcernMap = Object.assign({}, indexMap);
        const allSkinConcernOptions = Object.keys(selectedSkinConcernMap).sort().map(index => {
            return (
                <div key={ index } className="option">
                    <SelectButton name={ util.capitalize(skinConcernIcons[index - 1].replace(".svg", "").replace("-", " ")) } selectable={ isEditingProducts }
                        selected={ this.state.skinConcernsId && this.state.skinConcernsId.indexOf(parseInt(index, 10)) > -1 } id={ "skinconcern-" + index }
                        onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
                </div>
            );
        });

        //BUDGET
        let selectedBudgetMap = Object.assign({}, indexMapBudget);

        const allBudgetOptions = Object.keys(selectedBudgetMap).sort().map(index => {
            return (
                <div key={ index } className="option">
                    <SelectButton name={ budgetArray[index - 1] } selectable={ isEditingProducts }
                        selected={ parseInt((index), 10) === parseInt(this.state.budgetId, 10) } id={ "budget-" + index }
                        onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
                </div>
            );
        });

        return(
            <div className="rendered-block-section" >
                <div className="title-more-categories" onClick={ this.toggleCategoryEditSection }><div className={this.state.showCategoryEditSection ? "arrow rotate" : "arrow"}>&#9654;</div>edit customer preferences</div>
                <div className={ this.state.showCategoryEditSection ? "content-section bottom-section expanded" : "content-section bottom-section" }>
                    <div className="regimen-icons">
                        <h4>Products</h4>
                        <div className="deselected-products">
                            { allProductOptionsThreeFive }
                            <div className="create-your-own">
                                <div className="title create">Create Your Own</div>
                                { allProductOptions }
                            </div>

                        </div>

                    </div>
                    <div className="regimen-icons allergen-icons">
                        <h4>Allergens</h4>
                        <div className="options">{ allAllergicOptions }</div>
                    </div>
                    <div className="regimen-icons skin-concern-icons">
                        <h4>Skin Concerns</h4>
                        <div className="options">{ allSkinConcernOptions }</div>
                    </div>
                    <div className="regimen-icons budget-icons">
                        <h4>Budget</h4>
                        <div className="options">{ allBudgetOptions }</div>
                    </div>
                    <div className="category-button-section">
                        <button className="category-button cancel" onClick={ this.toggleCategoryEditSection } >Cancel</button>
                        <button className="category-button save" onClick={ this.savePreferences } >Save</button>
                    </div>
                </div>
            </div>
        );

    }

    toggleCategoryEditSection() {
        if (this.state.isEditingProducts) this.fetchResult();
        this.setState({ showCategoryEditSection: !this.state.showCategoryEditSection, isEditingProducts: !this.state.isEditingProducts });
    }

    fetchResult() {
        const userId = this.state.id;
        fetch('/api/surveys/result?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            this.setState({
                productTypes: responseJson.productTypes.length > 0 && (responseJson.productTypes.indexOf(9) === -1 && responseJson.productTypes.indexOf(10) === -1) ? responseJson.productTypes : [1,2,3],
                // budget: responseJson.selectedBudgetId,
                // skinConcerns: responseJson.skinConcerns,
                // allergicIngredients: responseJson.allergicIngredients
           });
            let indexNine = this.state.productTypes.indexOf(9);
            let indexTen = this.state.productTypes.indexOf(10);
            if (indexNine !== -1) this.state.productTypes.splice(indexNine, 1);
            if (indexTen !== -1) this.state.productTypes.splice(indexTen, 1);
        }).catch(function(err) {
            alert("There was a problem getting the customer's info. Please try again.");
        });
    }

    selectPasIcon(id) {
        const splits = id.split("-");
        const type = splits[0];
        let index = splits[1];

        if (type === 'product') {
            let productTypes = this.state.productTypes;
            index = parseInt(index, 10);
            if ((index !== 13) && (index !== 14)) {
                let indexThirteen = productTypes.indexOf(13);
                let indexFourteen = productTypes.indexOf(14);
                if (indexThirteen > -1) productTypes.splice(indexThirteen, 1);
                if (indexFourteen > -1) productTypes.splice(indexFourteen, 1);
                productTypes.push(parseInt(index,10));
                this.setState({ productTypes: productTypes });
            } else {
                productTypes = [];
                productTypes.push(index);
                this.setState({ productTypes: productTypes });
            }
        } else if (type === 'allergic') {
            let allergiesId = this.state.allergiesId;
            allergiesId.push(parseInt(index,10));
            this.setState({ allergiesId: allergiesId });
        } else if (type === 'skinconcern') {
            let skinConcernsId = this.state.skinConcernsId;
            skinConcernsId.push(parseInt(index,10));
            this.setState({ skinConcernsId: skinConcernsId });
        } else {
            this.setState({ budgetId: index });
        }

    }

    deselectPasIcon(id) {
        const splits = id.split("-");
        const type = splits[0];
        let index = splits[1];

        if (type === 'product') {
            let productTypes = this.state.productTypes;
            index = parseInt(index, 10);
            productTypes.splice(productTypes.indexOf(index), 1);
            if(this.state.productTypes.indexOf(index) === -1) productTypes.slice(this.state.productTypes.indexOf(index), 1);
            this.setState({ productTypes: productTypes });
        } else if (type === 'allergic') {
            let allergiesId = this.state.allergiesId;
            index = parseInt(index, 10);
            allergiesId.splice(allergiesId.indexOf(index), 1);
            if(this.state.allergiesId.indexOf(index) === -1) allergiesId.slice(this.state.allergiesId.indexOf(index), 1);
            this.setState({ allergiesId: allergiesId });
        } else if (type === 'skinconcern') {
            let skinConcernsId = this.state.skinConcernsId;
            index = parseInt(index, 10);
            skinConcernsId.splice(skinConcernsId.indexOf(index), 1);
            if(this.state.skinConcernsId.indexOf(index) === -1) skinConcernsId.slice(this.state.skinConcernsId.indexOf(index), 1);
            this.setState({ skinConcernsId: skinConcernsId });
        }
    }

    savePreferences() {
        this.saveAllergies();
    }

    saveProducts() {
        const productTypes = this.state.productTypes;
        const userId = this.state.id;
        const url = "/api/user-product-types?user-id=" + userId + "&options=" + productTypes;
        if (productTypes.length === 0) {
            alert("You must select at least one product type.");
            return;
        }
        fetch(url, {
            method: 'POST',
            headers: {
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                this.setState({ isEditingProducts: false, showCategoryEditSection: false });
                this.updateAfterChange();
            } else {
                alert("There was a problem to save the new categories. Please try again.");
            }
        });
    }

    saveAllergies() {
        const selectedIndices = this.state.allergiesId;
        const userId = this.state.id;
        if (selectedIndices.length === 0) {
            alert("You must select at least one option.");
            return;
        }
        const url = "/api/user-allergic-ingredients?user-id=" + userId + "&options=" + selectedIndices;
        fetch(url, {
            method: 'POST',
            headers: {
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                this.saveSkinConcerns();
            } else {
                alert("There was a problem saving your allergies. Please try again.");
            }
        });
    }

    saveSkinConcerns() {
        const selectedIndices = this.state.skinConcernsId;
        const userId = this.state.id;
        if (selectedIndices.length === 0) {
            alert("You must select at least one option.");
            return;
        }
        const url = "/api/user-skin-concerns?user-id=" + userId + "&options=" + selectedIndices;
        fetch(url, {
            method: 'POST',
            headers: {
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                this.saveBudget();
            } else {
                alert("There was a problem saving your skin concerns. Please try again.");
            }
        });
    }

    saveBudget() {
        const userId = this.state.id;
        const url = "/api/user-profiles";
        fetch(url, {
            method: 'PATCH',
            headers: {
                'x-auth-token': Api.auth_tokenManager(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                userId: userId,
                budgetId: parseInt(this.state.budgetId, 10),
            })
        }).then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                this.saveProducts();
            } else {
                alert("There is a problem saving budget preferences. Please try again.");
            }
        });
    }

    fun_hideUpdateEmailModel() {
      this.setState({
        isEmailEditButtonShow: true,
        isEmailEditInputShow: false
      })
    }

    fun_showUpdateEmailModel() {
      this.setState({
        isEmailEditButtonShow: false,
        isEmailEditInputShow: true
      })
    }


    fun_handleEditEmailInputChange(e){
      this.setState({
        updateEmialValue: e.target.value
      })
    }

    fun_saveEmail() {
      if(!this.state.updateEmialValue && this.state.updateEmialValue == ''){
        alert('emaill cannot be empty');
      }else if(! util.isValidEmail(this.state.updateEmialValue)){
        alert('Email format error');
      }else{
        fetch("/api/update-user-email", {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "x-auth-token": localStorage.getItem('auth_token'),
          },
          body: JSON.stringify({
            'id': this.state.id,
            'email': this.state.updateEmialValue,
          })
        }).then(response => {
             return response.json()
        }).then(responseJson => {
           this.fun_hideUpdateEmailModel();
           this.setState({email:this.state.updateEmialValue})
           alert("Modify successfully");
        }).catch(function(err) {
          alert("Failed to modify")
        });
      }
    }

    render() {

        const photoList = this.state.photos && this.state.photos.length > 0 ?
        this.state.photos.map((photoUrl,index) => {
            return <img key={index} alt={ photoUrl } src={ photoUrl } />
        }) :
        "No photos available";
      
        //For Regimen Card
        const skinType = this.state.skinType;
        const dryOily = !this.state.skinType ? null : (skinType.charAt(0) !== 'O' && skinType.charAt(0) !== 'C') && skinType.charAt(0) !== 'D' ? null : (skinType.charAt(0) === 'O'? "oily" : (skinType.charAt(0) === 'C'? "combination": "dry"));
        const sensitiveResistant = !this.state.skinType ? null : skinType.charAt(1) !== 'S' && skinType.charAt(1) !== 'R' ? null : (skinType.charAt(1) === 'S'? "sensitive" : "non-sensitive");
        const pigmented = !this.state.skinType ? null : skinType.charAt(2) !== 'H' && skinType.charAt(2) !== 'L' ? null : (skinType.charAt(2) === 'H'? "pigmented" : "non-pigmented");

        return (
                <div id="customer-portal" className="customer-portal">
                    {
                        this.state.loadingState ? <img alt="Loading" src="/images/loading.gif" className="load-position"/>: null
                    }

                    { this.state.loadingDone ?
                        (
                            !(this.state.noData) ?
                            <div className="customer-portal-body customer-info" style={{marginTop:'2em'}}>
                                <div className="user-info">
                                    <div className="info-item name"><span>Name:</span>  { this.state.name ? this.state.name : "No data available" }</div>
                                    <div className="info-item gender"><span>Gender:</span>  { this.state.gender ? this.state.gender : "No data available" }</div>
                                    <div className="info-item gender"><span>Pregnant:</span>  { this.state.pregnancy }</div>
                                    <div className="info-item phone-number"><span>Phone number:</span> { this.state.phoneNumber ? this.state.phoneNumber : "No data available"  }</div>
                                    <div className="info-item allergens"><span>Photos:</span>  { this.state.photos.length > 0 ? <a href="#/" onClick={ this.onOpenModal } >here</a> : "No photos available" }</div>
                                    <div className="info-item email">
                                      <span>Email:</span>
                                      { this.state.email ? this.state.email : "No data available" }
                                      <a className="info-edit-button" onClick={()=>{ this.fun_showUpdateEmailModel() }} style={this.state.isEmailEditButtonShow ? {display:'initial'} : {display:'none'} } >edit</a>
                                    </div>

                                    <div className="info-item email-edit" style={this.state.isEmailEditInputShow ? {display: 'flex'}:{display:'none'}}>
                                      <input className="info-edit-input" onChange={(e)=>{ this.fun_handleEditEmailInputChange(e)}} value={this.state.updateEmialValue}></input>
                                      <a className="info-edit-button" onClick={(e)=>{ this.fun_saveEmail() }}>save</a>
                                      <a className="info-edit-button" onClick={()=>{ this.fun_hideUpdateEmailModel() }}>cancel</a>
                                    </div>

                                    <div className="info-item age"><span>Age:</span> { this.state.age ? this.state.age : "No data available" }</div>
                                    <div className="info-item skin-type"><span>Skin type:</span> { this.state.skinType ? this.state.skinType : "No data available" }</div>
                                    <div className="info-item ethnicity"><span>Ethnicity:</span>  { this.state.ethnicity ? this.state.ethnicity : "No data available" } </div>
                                    <div className="info-item budget"><span>Budget:</span>  { this.state.budget !== undefined && this.state.budget !== null ? this.state.budget : "Not specified" }</div>
                                    <div className="info-item skin-concerns"><span>Skin concerns:</span>  { this.state.skinConcerns.length > 0 ? this.listUserChoices("skinConcerns") : "Not specified" }</div>
                                    <div className="info-item product-type"><span>Product types chosen:</span>  { this.state.productTypes.length > 0 ? this.listUserChoices("productTypesRender") : "Not specified" }</div>
                                    <div className="info-item allergens"><span>Allergens:</span>  { this.state.allergicIngredients.length > 0 ? this.listUserChoices("allergicIngredients") : "Not specified" }</div>
                                    
                                    <div className="info-item allergens"><span>Brands:</span>  { this.state.brands.length > 0 ? this.state.brands.join(", ") : "Not specified" }</div>
                                    
                                    <div className="info-item time-remaining"><span>Time Remaining:</span> { !this.state.paidGateFee ? "Hasn't paid gate fee" : this.state.defaultPurchaseOptOut ? "Opted-out" : !this.state.defaultPurchaseStarted && !this.state.defaultPurchaseComplete ? "Timer not started" : this.state.defaultPurchaseComplete && this.state.purchasedViaTimer ? "Purchased When Timer Expired" : this.state.defaultPurchaseComplete && !this.state.purchasedViaTimer ? "Purchased Before Timer Expired" : this.renderCountdownTimer() }</div>
                                    <div className="opt-out">
                                        {
                                            this.state.defaultPurchaseStarted ?
                                            <a href="#/" onClick={ this.handleOptOut } >
                                                Cancel Timer
                                            </a> :
                                            null
                                        }
                                    </div>
                                    <div className="next-user">
                                        <a href="#/" onClick={ () => { this.props.history.push('/portal/customer-tool') } }>
                                            Next User
                                            <i style={{fontSize:'22px', color: '#ffad94',marginLeft: '10px'}} className="fa fa-arrow-circle-right" aria-hidden="true"></i>
                                        </a>
                                    </div>

                                    <div className="info-item allergens">
                                        <span>Note:</span>
                                        <div>
                                            <textarea className="noteStyle" onChange={this.handleEditNoteEdit} name="note"  value={this.state.note}></textarea>
                                            <div style={{textAlign:'right'}}>
                                                <button style={{backgroundColor:'#8cacb5'}} onClick={()=>{this.fun_handleSubmitNote()}} className="ui primary button base-but-ac">
                                                        Save
                                                    <i className="fa fa-spinner fa-pulse pay-checkout-load" style={this.state.isCheckoutButton ? {display:'block'}:{display:'none'}}></i>
                                                </button>
                                            </div>
                                            
                                        </div>
                                    </div>

                                </div>

                                <div className="user-products">
                                    <div className="customer-portal-header">
                                        <div className={ "header-link user-info-products" + (this.state.showProducts ? " selected" : "") } onClick={ this.handleMenuClick } >
                                            User information and products
                                        </div>
                                        <div className={ "header-link user-order-history" + (!this.state.showProducts ? " selected" : "") } onClick={ this.handleMenuClick } >
                                            Order history
                                        </div>
                                    </div>
                                    <div className="user-info-body">
                                        {
                                            this.state.showProducts ?
                                            <div className="leavingAmessage-user-area">
                                                <div className="leavingAmessage-user-area-title">
                                                    <span>Note to customer (shown on recommendation page)</span>
                                                    {
                                                        this.state.operationStep == 'save' ?  <a onClick={()=>{ this.fun_saveNoteCustomer() }}>save</a>
                                                        : <a onClick={()=>{ this.fun_stepChange() }}>edit</a>
                                                    }
                                                </div>
                                                <div className="leavingAmessage-user-area-conten">
                                                    <textarea id="custNoteDom" readOnly={this.state.operationStep == 'save' ? false : 'readOnly'} name="leavingAmessageNode" onChange={this.handleEditNoteEdit} className="leavingAmessage-user-area-conten-input" value={this.state.leavingAmessageNode}></textarea>
                                                </div>
                                            </div>:null
                                        }
                                        
                                        {
                                            this.state.showProducts ?
                                            this.renderProductRows() :
                                            <CustomerOrderHistory
                                                id={ this.state.id }
                                                onOpenRegimenModal={ this.handleDummyDiv }
                                                getSelectedOrderForRegimenCard={ this.getSelectedOrderForRegimenCard }
                                            />
                                        }
                                        { this.state.showProducts ? this.renderBlockSection() : null }
                                    </div>
                                </div>

                            </div> :
                            <div className="customer-info">
                                <div className="user-info"></div>
                                <div className="user-products">
                                    <div className="loading">No data available for this email address.</div>
                                </div>
                            </div>

                        ) :
                        <div className="customer-info">
                            <div className="user-info"></div>
                            <div className="user-products">
                                <div className="loading">Retrieving customer info...</div>
                            </div>
                        </div>
                    }
                    <Modal open={ this.state.showPhotoModal } onClose={ this.onCloseModal } little classNames={{ overlay: 'ha-overlay', modal: 'referral-modal photo-modal' }}>
                        <div className="photo-list">
                            { photoList }
                        </div>
                    </Modal>
                    <Modal style={ { overlay: { height: 750, width: 800 } }} open={ this.state.showRegimenModal } onClose={ this.onCloseRegimenModal } little classNames={{ overlay: 'ha-overlay', modal: this.state.hideButtons ? 'referral-modal regimen-modal print' : 'referral-modal regimen-modal' }}>
                        {
                            !this.state.showEditMode ?
                            <div style={ this.state.hideButtons ? { "height": "100%", "maxWidth": "10000px", "width": "100%" } : null}  className="regimen-module">
                                { !this.state.hideButtons ? <button className="alt edit" onClick={ this.toggleEditMode } >Edit</button> : null }
                                { !this.state.hideButtons ? <img alt="Regimen card" src={this.state.imageURL} /> : null }
                                <div className="download-print-buttons">
                                    { !this.state.hideButtons ? <button className="standard download"><a href={ this.state.imageURL } download={ this.state.name.toString().split(" ").length > 1 ?
                                        this.state.name.toString().split(" ")[0] + "_" + this.state.name.toString().split(" ")[1] + "_download_date_" + this.generateDate() : this.state.name }>Download</a></button>: null }
                                    { !this.state.hideButtons ? <button className="standard download" onClick={ this.printImage } >Print</button> : null}
                                </div>
                            </div> :
                            <div className="regimen-module">
                                <div className="edit-mode">
                                    {/* <div className="edit-left">
                                        <img alt="Regimen card" src={this.state.imageURL} width="354.2" height="249.54" />
                                    </div> */}
                                    <div className="edit-right">
                                    <div className="edit-right-top">
                                        <div className="edit-title">Your regimen:</div>
                                        <ContentEditable
                                            html={ this.state.editHtml }
                                            disabled={ false }
                                            onChange={ this.handleEditInputChange }
                                        />
                                    </div>
                                    <div className="edit-right-bottom">
                                        <button className="alt cancel" onClick={ this.handleEditCancel } >Cancel</button>
                                        <button className="standard save" onClick={ this.generateEditedRegimenCard } >Save</button>
                                        <a href="#/" onClick={ this.handleEditReset }>Reset</a>
                                    </div>
                                </div>
                                </div>
                            </div>
                        }
                    </Modal>
                    {
                        this.state.showPrintImg ?
                        <div className="print-window-customerinfo" id="print-window-customerinfo">
                            <img alt="Regimen card" src={this.state.imageURL}  />
                        </div>
                        : null
                    }
                    {
                        this.state.showDummyDiv ?
                        <div id="regimen-card-dummy" className="regimen-card-dummy">
{/*                         
                            <div className="card-left">
                                <div className="card-left-name">Hello <span>{ util.capitalize(this.state.name.toString().split(" ")[0]) }</span></div>
                                <div className="card-left-quote">{ this.generateQuote() }</div>
                            </div> */}

                            <div className="card-right">
                                <div className="card-right-logo">
                                    <img alt="HelloAva" src="/images/logo.png" />
                                </div>
                                <div className="card-right-block card-right-top">
                                    <div className="shadow-style"></div>
                                    <div className="card-right-top-section-1">
                                        <div className="card-right-title">Made for</div>
                                        <div className="card-right-name">{ util.capitalize(this.state.name.toString()) }</div>
                                    </div>
{/*                                     
                                    <div className="card-right-top-section-2">
                                        <div className="section-2-section skin-type-section">
                                            <div className="card-right-title">Skin type</div>
                                            <div className="card-skin-type">{ this.state.skinType }</div>
                                        </div>
                                        <div className="section-2-section social">
                                            Join your community by tagging #HELLO{ this.state.skinType.replace("W","M").toLowerCase() } and see what’s working for your fellow { this.state.skinType.replace("W", "M") }s, also tag @helloavabeauty to get featured
                                        </div>
                                    </div> */}

                                    <div className="card-right-top-section-3">
                                        <div className="card-right-title-skin-type-solid"></div>
                                        <div className="card-right-title-skin-type">Skin type</div>
                                        {
                                            this.state.skinImageExists  ?
                                            <div className="skin-type">
                                              <img
                                                alt={this.state.skinType ? this.state.skinType : "Your skin type"}
                                                className="full-skin-type"
                                                src={"/images/customerType/" + this.state.skinType + ".svg"}
                                                onError={() => this.setState({ skinImageExists: false })}
                                              />
                                            </div> :
                                            <div className="skin-type cust-t-skintype-area">
                                                <div className="column">
                                                    <img alt={ dryOily } src={ "/images/onboarding/skintypeupdated/" + dryOily + ".svg" } />
                                                    <div className="type">{ dryOily }</div>
                                                </div>
                                                <div className="column">
                                                    <img alt={ sensitiveResistant } src={ "/images/onboarding/skintypeupdated/" + sensitiveResistant + ".svg" } />
                                                    <div className="type">{ sensitiveResistant }</div>
                                                </div>
                                                <div className="column">
                                                    <img alt={ pigmented } src={ "/images/onboarding/skintypeupdated/" + pigmented + ".svg" } />
                                                    <div className="type">{ pigmented }</div>
                                                </div>
                                                <div className="column">
                                                    <img alt={ this.state === 'W'? "mature" : "youthful"  } src={ "/images/onboarding/skintypeupdated/" +  this.state.wrinkled + ".svg" } />
                                                    <div className="type">{ this.state.wrinkledType === 'W'? "mature" : "youthful" }</div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="card-right-block card-right-middle">
                                    <div className="shadow-style"></div>
                                    <div className="card-right-title">Your regimen</div>
                                    <ContentEditable
                                        html={ this.state.editHtml }
                                        disabled={ true }
                                        onChange={ this.handleEditInputChange }
                                    />
                                </div>
                                <div className="card-right-block card-right-bottom">
                                    <div className="shadow-style"></div>
                                    <div className="card-right-bottom-section-1">
                                        <div className="card-right-title curtedby-helloava">Curated by</div>
                                        <div className="card-right-title-conten-text">HelloAva</div>
                                    </div>
                                    <div className="card-right-bottom-section-2">
                                        <div className="card-right-title made-on">Made on</div>
                                    <div className="card-right-title-conten-text">{getTodayDate()}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        // <ShareModuleDummyDiv
                        //     name={userFirstName}
                        //     skinTypeAcronym={skinType}
                        //     dryOily={dryOily}
                        //     sensitiveResistant={sensitiveResistant}
                        //     pigmented={pigmented}
                        //     wrinkled={wrinkled}
                        //     genderId={this.state.selectedGenderId}
                        //     summary={this.state.description}
                        // /> : null
                        : null
                    }

                </div>
        );
    }
}

export default withRouter(CustomerInfoAndProducts);



// WEBPACK FOOTER //
// ./src/views/customersuccessportal/CustomerInfoAndProducts.js